var api = "https://api.qingcigame.com";

var requestInterface = {};
var routerParams = {};

var obj = {
  index: function () {
    if (!this.is_weixn()) {
      return window.location.replace("guide.html");
    }
    this.indexBind(); // 首页按钮
    this.onInit();
  },
  is_weixn: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },
  indexBind: function () {
    // 通用绑定事件
    $(".close_bg").on("click", function () {
      $(".popup").fadeOut();
    });

    // 点击蒙版层关闭
    $(".mask").on("click", function () {
      $(".popup").fadeOut();
    });

    // 点击助力按钮
    $(".btn").on("click", function () {
      obj.inviteFun();
    });

    // 点击头部前往预约按钮
    $(".yy").on("click", function () {
      requestInterface.countNum("助力页_点击头部前往预约按钮");
    });

    // 点击助力成功弹窗前往预约按钮
    $(".success_pop .btn").on("click", function () {
      requestInterface.countNum("助力页_点击助力成功弹窗前往预约按钮");
    });

    // 点击助力失败弹窗前往预约按钮
    $(".fail_pop .btn").on("click", function () {
      requestInterface.countNum("助力页_点击助力失败弹窗前往预约按钮");
    });
  },
  // 初始化用户信息
  onInit: function () {
    requestInterface.init({}, function (response) {
      if (response.code == 302) {
        window.location.href =
          response.data.wechat_url +
          "?callback=" +
          encodeURI(window.location.href);
        return;
      }
    });
  },
  // 助力
  inviteFun: function () {
    requestInterface.invite({}, function (response) {
      if (response.code == 302) {
        window.location.href =
          response.data.wechat_url +
          "?callback=" +
          encodeURI(window.location.href);
      } else if (response.code == 200) {
        $(".success").show();
      } else if (response.code == 407) {
        $(".fail").show();
      } else if (response.code == 406) {
        layer.msg(response.message);
      } else if (response.code == 405) {
        $(".help").show();
      } else {
        layer.msg(response.message);
      }
    });
  },
};

requestInterface = {
  // 业务接口
  init: function (data = {}, callback) {
    routerParams = analysisParams(window.location.href);
    data.company = routerParams.company;
    data.invitation_code = routerParams.code;
    data.book_token = localStorage.getItem("access_token") || "";
    data.app_id = 82;
    const index = layer.load(1);
    $.ajax({
      url: api + "/blade/book/init",
      type: "GET",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        if (json.code != 200 && json.code != 401) {
          // layer.msg(json.message);
        }
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  // 助力好友
  invite: function (data = {}, callback) {
    routerParams = analysisParams(window.location.href);
    data.invitation_code = routerParams.code || "";
    const index = layer.load(1);
    $.ajax({
      url: api + "/blade/book/invite",
      type: "POST",
      data,
      xhrFields: { withCredentials: true },
      success: function (json) {
        callback && callback(json);
      },
      complete: function () {
        layer.close(index);
      },
    });
  },
  countNum: function (data) {
    setTimeout(() => {
      try {
        __bl.sum(data);
        window.location.href =
          "https://h5.qingcigame.com/pre-registration/index_mobile.html";
      } catch (e) {
        console.log(e);
      }
    }, 500);
  },
};

function analysisParams(url) {
  const params = {};
  const paramsString = url.split("?")[1];
  if (!paramsString) {
    return params;
  }
  const str = paramsString.split("&");
  for (let idx = 0; idx < str.length; idx++) {
    const values = str[idx].split("=");
    params[values[0]] = values[1];
  }
  return params;
}
